import { useState, useEffect } from 'react'
import {
    Card,
    CardHeader,
    Container,
    Row,
    Col,
    CardBody,
} from "reactstrap";
import Header from 'components/Headers/Header'
import Payment from './Payment';
import '../../assets/css/custom-modal.css'
import { connect, useDispatch } from 'react-redux';
import { getPlansForSpecialty, getEffectivePrice, getEffectivePricePerMonth, isTrialValid, getTrialDaysRemaining, isSubscriptionValid, getSubscriptionDaysRemaining, getSpecialtyFields, qualifiesForAddon, getAddonPrice, ADDON_DISCOUNT_PERCENT, BUNDLES, getBundlePrice, getBundlePlanIds, SUBSCRIPTION_PLANS, hasPaidAccess } from 'config/subscriptionPlans';
import { getSpecialty, SPECIALTY_IDS } from 'config/specialtyConfig';
import StartTrialButton from 'components/Trial/StartTrialButton';
import RedeemGroupCode from 'components/GroupOrders/RedeemGroupCode';
import QuickBuyModal from 'components/Billing/QuickBuyModal';
import AddOnSpecialtyBanks from 'components/Billing/AddOnSpecialtyBanks';
import { listPaymentMethods } from 'redux/Billing/BillingActions';

const Plans = (props) => {
    const dispatch = useDispatch();
    const [plan, setPlan] = useState('')
    const [subscribe, setSubscribe] = useState('lock');
    const [trialDaysLeft, setTrialDaysLeft] = useState(0);
    const [subscriptionDaysLeft, setSubscriptionDaysLeft] = useState(0);
    const [isOnTrial, setIsOnTrial] = useState(false);
    const [isOnSubscription, setIsOnSubscription] = useState(false);
    const [quickBuyPlan, setQuickBuyPlan] = useState(null);
    const [viewMode, setViewMode] = useState('bundles');
    const [bundleDuration, setBundleDuration] = useState(12);
    const [quickBuyBundle, setQuickBuyBundle] = useState(null);

    const fetchSubscriptionDetails = () => {
        const userDetails = props.userDetails;
        const fields = getSpecialtyFields(props.activeSpecialty);

        // Check for Lifetime Access (bypass payment)
        if (userDetails[fields.lifetimeAccess] == true || userDetails[fields.lifetimeAccess] == "true") {
            setSubscribe('unlock')
            return;
        }

        // Check for Ultimate Advising Student
        if (userDetails[fields.ultimateAdvisingStudent] == true || userDetails[fields.ultimateAdvisingStudent] == "true") {
            setSubscribe('unlock')
            return;
        }

        // Check for one-time subscription (subscriptionEndDate)
        const subEndDate = userDetails[fields.subscriptionEndDate];
        if (subEndDate) {
            const subValid = isSubscriptionValid(subEndDate);
            const daysRemaining = getSubscriptionDaysRemaining(subEndDate);

            setIsOnSubscription(subValid);
            setSubscriptionDaysLeft(daysRemaining);

            if (subValid) {
                setSubscribe('unlock')
                return;
            }
        }

        // Check for free trial
        const trialStart = userDetails[fields.trialStartDate];
        if (trialStart) {
            const trialValid = isTrialValid(trialStart);
            const daysRemaining = getTrialDaysRemaining(trialStart);

            setIsOnTrial(trialValid);
            setTrialDaysLeft(daysRemaining);

            if (trialValid) {
                setSubscribe('unlock')
                return;
            }
        }

        setSubscribe('lock')
    }

    useEffect(() => {
        fetchSubscriptionDetails()
        // Load saved cards so we can offer quick-buy when a default card exists
        dispatch(listPaymentMethods()).catch(() => { /* handled */ });
    }, [])

    useEffect(() => {
        fetchSubscriptionDetails()
    }, [props.fetchDetailsSubscription, props.userDetails, props.activeSpecialty])

    const defaultCard = (props.paymentMethods || []).find(pm => pm.isDefault);
    const isAddon = qualifiesForAddon(props.userDetails, props.activeSpecialty);

    const getDisplayPrice = (plan) => {
        if (isAddon) return getAddonPrice(plan, isOnTrial);
        return getEffectivePrice(plan, isOnTrial);
    };
    const getDisplayPricePerMonth = (plan) => {
        if (isAddon) return getAddonPrice(plan, isOnTrial) / plan.months;
        return getEffectivePricePerMonth(plan, isOnTrial);
    };

    const handleSelectPlan = (subscriptionPlan) => {
        if (defaultCard) {
            setQuickBuyPlan(subscriptionPlan);
        } else {
            setPlan(subscriptionPlan.priceId);
        }
    };

    const getColorClass = (color) => {
        const colorMap = {
            info: 'bg-info',
            success: 'bg-success',
            warning: 'bg-warning',
            primary: 'bg-primary',
            default: 'bg-default',
            danger: 'bg-danger'
        };
        return colorMap[color] || 'bg-info';
    };

    const getBtnClass = (color) => {
        const colorMap = {
            info: 'btn-info',
            success: 'btn-success',
            warning: 'btn-warning',
            primary: 'btn-primary',
            default: 'btn-default',
            danger: 'btn-danger'
        };
        return colorMap[color] || 'btn-info';
    };

    return (
        <>
            <Header></Header>
            <Container className='mt--7' fluid>
                {plan == "" ?
                    <>
                        <Row>
                            <div className="col">
                                <Row>
                                    <Col lg="12" className='mt-3'>
                                        <Card className='border-0 shadow'>
                                            <CardBody>
                                                <Row>
                                                    <Col lg="12">
                                                        {viewMode === 'bundles' ? (
                                                            <div className="text-center mb-0">
                                                                <p className='display-3 mb-0 text-dark'>Bundle & Save</p>
                                                                <p className='h3 text-gray mb-0'>Purchase multiple specialties together at a discounted rate</p>
                                                            </div>
                                                        ) : (
                                                        <>
                                                        <div className="text-center mb-0">
                                                            <p className='display-3 mb-0 text-dark'>{getSpecialty(props.activeSpecialty).name} Prep Subscription Plans</p>
                                                            <p className='h3 text-gray mb-0'>Choose the plan that fits your exam preparation timeline</p>
                                                        </div>

                                                        {(props.userDetails[getSpecialtyFields(props.activeSpecialty).lifetimeAccess] == true || props.userDetails[getSpecialtyFields(props.activeSpecialty).lifetimeAccess] == "true") && (
                                                            <div className="alert alert-success text-center mt-3">
                                                                <i className="fas fa-infinity mr-2"></i>
                                                                <strong>Lifetime Access Active!</strong> You have permanent full access to {getSpecialty(props.activeSpecialty).name} Prep.
                                                            </div>
                                                        )}

                                                        {(props.userDetails[getSpecialtyFields(props.activeSpecialty).ultimateAdvisingStudent] == true || props.userDetails[getSpecialtyFields(props.activeSpecialty).ultimateAdvisingStudent] == "true") && !(props.userDetails[getSpecialtyFields(props.activeSpecialty).lifetimeAccess] == true || props.userDetails[getSpecialtyFields(props.activeSpecialty).lifetimeAccess] == "true") && (
                                                            <div className="alert alert-success text-center mt-3">
                                                                <i className="fas fa-star mr-2"></i>
                                                                <strong>Ultimate Advising Student!</strong> You have full access to {getSpecialty(props.activeSpecialty).name} Prep.
                                                            </div>
                                                        )}

                                                        {isOnSubscription && !(props.userDetails[getSpecialtyFields(props.activeSpecialty).lifetimeAccess] == true || props.userDetails[getSpecialtyFields(props.activeSpecialty).lifetimeAccess] == "true") && !(props.userDetails[getSpecialtyFields(props.activeSpecialty).ultimateAdvisingStudent] == true || props.userDetails[getSpecialtyFields(props.activeSpecialty).ultimateAdvisingStudent] == "true") && (
                                                            <div className="alert alert-success text-center mt-3">
                                                                <i className="fas fa-check-circle mr-2"></i>
                                                                <strong>Subscription Active!</strong> You have {subscriptionDaysLeft} day{subscriptionDaysLeft !== 1 ? 's' : ''} remaining.
                                                                {subscriptionDaysLeft <= 30 && ' Extend your subscription to continue your preparation!'}
                                                            </div>
                                                        )}

                                                        {isOnTrial && !isOnSubscription && (
                                                            <div className="alert alert-danger text-center mt-3">
                                                                <i className="fas fa-fire mr-2"></i>
                                                                <strong>Your free trial {trialDaysLeft === 0 ? 'ends today' : `ends in ${trialDaysLeft} day${trialDaysLeft !== 1 ? 's' : ''}`}!</strong>{' '}
                                                                Subscribe now to keep your access and continue your preparation.
                                                            </div>
                                                        )}

                                                        {!isOnTrial && !isOnSubscription && subscribe === 'lock' && !props.userDetails[getSpecialtyFields(props.activeSpecialty).trialStartDate] && (
                                                            <div className="alert alert-success text-center mt-3">
                                                                <i className="fas fa-gift mr-2"></i>
                                                                <strong>New User?</strong> Start your 14-day free trial today! You won't be charged until your trial ends.
                                                                <div className="mt-3">
                                                                    <StartTrialButton />
                                                                </div>
                                                            </div>
                                                        )}

                                                        {!isOnTrial && !isOnSubscription && subscribe === 'lock' && props.userDetails[getSpecialtyFields(props.activeSpecialty).trialStartDate] && (
                                                            <div className="alert alert-warning text-center mt-3">
                                                                <i className="fas fa-exclamation-triangle mr-2"></i>
                                                                <strong>Your access has expired.</strong> Choose a plan below to renew your subscription.
                                                            </div>
                                                        )}
                                                        </>
                                                        )}
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        </Row>

                        {/* View mode toggle */}
                        <Row className='mt-3'>
                            <Col lg="12">
                                <div className="d-flex justify-content-center">
                                    <div className="btn-group" role="group">
                                        <button
                                            type="button"
                                            className={`btn ${viewMode === 'individual' ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => setViewMode('individual')}
                                        >
                                            <i className="fas fa-book mr-1" /> Individual Plans
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn ${viewMode === 'bundles' ? 'btn-warning' : 'btn-outline-warning'}`}
                                            onClick={() => setViewMode('bundles')}
                                        >
                                            <i className="fas fa-layer-group mr-1" /> Bundle & Save
                                        </button>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {viewMode === 'individual' && <AddOnSpecialtyBanks />}

                        <Row className='mt-3'>
                            <Col lg="12">
                                <Card className='border-0 shadow'>
                                    <CardBody className="py-3">
                                        <p className="h4 text-dark mb-2">
                                            <i className="fas fa-users mr-2 text-primary" />
                                            Have a Group Access Code?
                                        </p>
                                        <RedeemGroupCode />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        {viewMode === 'bundles' && (
                            <Row className='mt-4'>
                                <Col lg="12">
                                    <Card className='border-0 shadow'>
                                        <CardBody>
                                            <div className="text-center mb-3">
                                                <p className="display-4 text-dark mb-1">Bundle Multiple Specialties & Save</p>
                                                <p className="text-muted">Purchase access to multiple specialty question banks at a discounted rate</p>
                                            </div>

                                            {/* Duration selector */}
                                            <div className="d-flex justify-content-center flex-wrap mb-4" style={{ gap: '8px' }}>
                                                {SUBSCRIPTION_PLANS.filter(p => ![48].includes(p.months)).map((p) => (
                                                    <button
                                                        key={p.months}
                                                        type="button"
                                                        className={`btn btn-sm ${bundleDuration === p.months ? 'btn-primary' : 'btn-outline-primary'}`}
                                                        onClick={() => setBundleDuration(p.months)}
                                                    >
                                                        {p.months} mo
                                                    </button>
                                                ))}
                                            </div>

                                            <Row>
                                                {BUNDLES.filter(bundle => {
                                                    // Hide bundles where user already owns all included specialties
                                                    return !bundle.specialties.every(specId => hasPaidAccess(props.userDetails, specId));
                                                }).map((bundle) => {
                                                    const basePlan = SUBSCRIPTION_PLANS.find(p => p.months === bundleDuration);
                                                    if (!basePlan) return null;
                                                    const pricing = getBundlePrice(basePlan, bundle, getEffectivePrice(basePlan, isOnTrial));
                                                    const planIds = getBundlePlanIds(basePlan, bundle);
                                                    return (
                                                        <Col xl="3" lg="4" md="6" className="d-flex mt-3" key={bundle.id}>
                                                            <Card className="border-0 shadow w-100" style={{ position: 'relative' }}>
                                                                <span
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '-12px',
                                                                        left: '20px',
                                                                        zIndex: 100,
                                                                        fontSize: '0.85rem',
                                                                        padding: '8px 18px',
                                                                        backgroundColor: '#f5365c',
                                                                        color: '#fff',
                                                                        borderRadius: '50px',
                                                                        fontWeight: '600',
                                                                        boxShadow: '0 4px 6px rgba(0,0,0,0.2)'
                                                                    }}
                                                                >
                                                                    Save {pricing.discountPercent}%
                                                                </span>
                                                                {bundle.popular && (
                                                                    <span
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: '-12px',
                                                                            right: '20px',
                                                                            zIndex: 100,
                                                                            fontSize: '0.85rem',
                                                                            padding: '8px 18px',
                                                                            backgroundColor: '#fb6340',
                                                                            color: '#fff',
                                                                            borderRadius: '50px',
                                                                            fontWeight: '600',
                                                                            boxShadow: '0 4px 6px rgba(0,0,0,0.2)'
                                                                        }}
                                                                    >
                                                                        Best Value
                                                                    </span>
                                                                )}
                                                                <CardHeader
                                                                    className={`${getColorClass(bundle.color)} d-flex justify-content-center align-items-center`}
                                                                    style={{ minHeight: '180px' }}
                                                                >
                                                                    <div className="text-center">
                                                                        <h1 className="h3 mb-2 text-white">{bundle.name}</h1>
                                                                        <h2 className="display-2 mb-0 text-white">
                                                                            ${pricing.totalPrice}
                                                                            <span className="h4 text-white-50 ml-2" style={{ textDecoration: 'line-through' }}>
                                                                                ${pricing.individualTotal}
                                                                            </span>
                                                                        </h2>
                                                                        <p className="h4 text-white-50 mb-0">{bundleDuration} months access</p>
                                                                    </div>
                                                                </CardHeader>
                                                                <CardBody>
                                                                    <div className="text-center">
                                                                        <p className="text-success font-weight-bold mb-2">
                                                                            <i className="fas fa-tag mr-1" />
                                                                            Save ${pricing.savedAmount}!
                                                                        </p>
                                                                        <p className="h4 text-dark mb-3">Includes:</p>
                                                                        <ul className="list-unstyled mb-3">
                                                                            {bundle.specialties.map(specId => (
                                                                                <li key={specId} className="py-1">
                                                                                    <i className={`${getSpecialty(specId).icon} mr-2 text-${getSpecialty(specId).color}`} />
                                                                                    {getSpecialty(specId).name} Prep
                                                                                    {hasPaidAccess(props.userDetails, specId) && (
                                                                                        <span className="badge badge-success ml-2">Active</span>
                                                                                    )}
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                        <button
                                                                            className={`btn ${getBtnClass(bundle.color)} w-100`}
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                if (defaultCard) {
                                                                                    setQuickBuyBundle({ bundle, basePlan, pricing, planIds });
                                                                                } else {
                                                                                    // Navigate to Payment page with bundle info
                                                                                    setPlan('__bundle__');
                                                                                }
                                                                            }}
                                                                        >
                                                                            Choose Bundle
                                                                        </button>
                                                                    </div>
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    );
                                                })}
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        )}

                        {viewMode === 'individual' && (<Row className='mt-4'>
                            <div className="col">
                                <Row>
                                    {getPlansForSpecialty(props.activeSpecialty).filter((subscriptionPlan) => {
                                        // 48-month plan is targeted at incoming PGY1s only (PMR only)
                                        if (props.activeSpecialty === 'pmr' && subscriptionPlan.id.endsWith('48Months339')) {
                                            return props.userDetails?.[getSpecialtyFields(props.activeSpecialty).year] === 'PGY 1';
                                        }
                                        return true;
                                    }).map((subscriptionPlan) => {
                                        const effectivePrice = getDisplayPrice(subscriptionPlan);
                                        const effectivePricePerMonth = getDisplayPricePerMonth(subscriptionPlan);
                                        return (
                                        <Col xl="3" lg="4" md="6" className='d-flex mt-3' key={subscriptionPlan.id}>
                                            <Card className='border-0 shadow w-100' style={{ position: 'relative' }}>
                                                {subscriptionPlan.popular && (
                                                    <span
                                                        style={{
                                                            position: 'absolute',
                                                            top: '-12px',
                                                            right: '20px',
                                                            zIndex: 100,
                                                            fontSize: '0.85rem',
                                                            padding: '8px 18px',
                                                            backgroundColor: '#fb6340',
                                                            color: '#fff',
                                                            borderRadius: '50px',
                                                            fontWeight: '600',
                                                            boxShadow: '0 4px 6px rgba(0,0,0,0.2)'
                                                        }}
                                                    >
                                                        Most Popular
                                                    </span>
                                                )}
                                                <CardHeader
                                                    className={`${getColorClass(subscriptionPlan.color)} d-flex justify-content-center align-items-center`}
                                                    style={{ minHeight: "180px" }}
                                                >
                                                    <div className="text-center">
                                                        <h1 className="h3 mb-0 text-white">{subscriptionPlan.name}</h1>
                                                        <h2 className="display-2 mb-0 text-white">
                                                            ${effectivePrice}
                                                        </h2>
                                                        <p className='h4 text-white-50 mb-0'>
                                                            ${effectivePricePerMonth.toFixed(2)}/month
                                                        </p>
                                                    </div>
                                                </CardHeader>
                                                <CardBody>
                                                    <Row className="pl-2 pr-2 h-100">
                                                        <Col lg='12' className='d-flex align-items-center flex-column h-100' style={{ minHeight: "150px" }}>
                                                            {isAddon && (
                                                                <p className="text-success font-weight-bold mb-2 text-center" style={{ fontSize: '0.85rem' }}>
                                                                    <i className="fas fa-tag mr-1"></i>
                                                                    Extra {ADDON_DISCOUNT_PERCENT}% add-on discount applied!
                                                                </p>
                                                            )}
                                                            <p className="h4 mb-0 text-dark mb-3 text-center">
                                                                {subscriptionPlan.description}
                                                            </p>
                                                            <ul className="list-unstyled mt-2 mb-3 text-sm">
                                                                <li><i className="fas fa-check text-success mr-2"></i>Full Question Bank Access</li>
                                                                <li><i className="fas fa-check text-success mr-2"></i>Performance Analytics</li>
                                                                <li><i className="fas fa-check text-success mr-2"></i>Practice Tests</li>
                                                            </ul>
                                                            <button
                                                                className={`btn ${getBtnClass(subscriptionPlan.color)} mt-auto w-100`}
                                                                onClick={e => { e.preventDefault(); handleSelectPlan(subscriptionPlan) }}
                                                            >
                                                                Choose Plan
                                                            </button>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    )})}
                                </Row>
                            </div>
                        </Row>
                        )}
                    </>
                    : plan === '__bundle__' && quickBuyBundle?.bundle && quickBuyBundle?.basePlan && quickBuyBundle?.pricing ? (
                        <Payment
                            selectedPlan={quickBuyBundle.basePlan.priceId}
                            isBundle={true}
                            bundleId={quickBuyBundle.bundle.id}
                            bundleTotalPrice={quickBuyBundle.pricing.totalPrice}
                            bundleName={quickBuyBundle.bundle.name}
                            bundleSpecialties={quickBuyBundle.bundle.specialties}
                        />
                    ) : <Payment selectedPlan={plan} isAddon={isAddon}></Payment>}
            </Container>
            <QuickBuyModal
                isOpen={!!quickBuyPlan}
                toggle={() => setQuickBuyPlan(null)}
                plan={quickBuyPlan}
                defaultCard={defaultCard}
                userDetails={props.userDetails}
                activeSpecialty={props.activeSpecialty}
                isAddon={isAddon}
                addonPrice={isAddon && quickBuyPlan ? getAddonPrice(quickBuyPlan, isOnTrial) : null}
                onUseDifferentCard={() => {
                    const chosen = quickBuyPlan;
                    setQuickBuyPlan(null);
                    if (chosen) setPlan(chosen.priceId);
                }}
            />
            {/* Bundle QuickBuyModal */}
            <QuickBuyModal
                isOpen={!!quickBuyBundle}
                toggle={() => setQuickBuyBundle(null)}
                plan={quickBuyBundle?.basePlan || null}
                defaultCard={defaultCard}
                userDetails={props.userDetails}
                activeSpecialty={props.activeSpecialty}
                isBundle={true}
                bundle={quickBuyBundle?.bundle || null}
                bundlePlanIds={quickBuyBundle?.planIds || null}
                bundleTotalPrice={quickBuyBundle?.pricing?.totalPrice || 0}
                onUseDifferentCard={() => {
                    const bundleData = quickBuyBundle;
                    setQuickBuyBundle(null);
                    if (bundleData) {
                        setPlan('__bundle__');
                    }
                }}
            />
        </>
    )
}

const mapStateToProps = state => {
    return {
        userDetails: state.loginAuth.userDetails,
        fetchDetailsSubscription: state.fetchDetailsSubscription,
        adminUser: state.adminUser,
        paymentMethods: state.paymentMethods?.paymentMethods || [],
        activeSpecialty: state.specialty.activeSpecialty,
    }
}

export default connect(mapStateToProps)(Plans)
